import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";

export const TopNavBar: React.FC = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const whatsappLink = "https://wa.me/27679376048";

  const pathname = location.pathname.replace(/\/$/, "") || "/";

  const isHome = pathname === "/";
  const isAbout = pathname === "/about";
  const isServices = pathname === "/services";
  const isContact = pathname === "/contact";

  const desktopLinkClass = (isActive: boolean) =>
    isActive
      ? "text-primary dark:text-primary-fixed font-bold border-b-2 border-primary dark:border-primary-fixed pb-1"
      : "text-on-surface-variant dark:text-on-surface-variant hover:text-primary dark:hover:text-primary-fixed transition-colors";

  const mobileLinkClass = (isActive: boolean) =>
    isActive
      ? "text-primary bg-secondary-container/50 border-secondary font-semibold"
      : "text-on-surface-variant hover:text-primary transition-colors border-transparent";

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-white sticky top-0 border-b border-outline-variant z-50 full-width">
      <div className="flex justify-between items-center px-lg py-sm w-full max-w-container-max mx-auto">
        <Link to="/" className="shrink-0 flex items-center gap-sm">
          <BrandLogo imageClassName="h-10 w-auto md:h-12" />
          <span className="flex flex-col leading-tight">
            <span className="font-headline-md text-primary text-sm md:text-base tracking-wide">
              Kolomaka Cleaning
            </span>
            <span className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-on-surface-variant">
              Services
            </span>
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-lg relative">
          <Link className={desktopLinkClass(isHome)} to="/">
            Home
          </Link>
          <Link className={desktopLinkClass(isAbout)} to="/about">
            About
          </Link>

          <Link className={desktopLinkClass(isServices)} to="/services">
            Services
          </Link>

          <Link className={desktopLinkClass(isContact)} to="/contact">
            Contact Us
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-primary dark:text-primary-fixed"
          onClick={toggleMobileMenu}
        >
          <span className="material-symbols-outlined text-2xl">
            {mobileMenuOpen ? "close" : "menu"}
          </span>
        </button>

        <a
          className="hidden md:inline-flex bg-brand-gradient text-on-primary px-md py-sm font-bold scale-95 duration-150 ease-in-out hover:brightness-110 transition-all rounded-lg"
          href={whatsappLink}
          target="_blank"
          rel="noreferrer"
        >
          Get a Quote
        </a>
      </div>

      {/* Mobile Navigation Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-outline-variant">
          <div className="flex flex-col px-lg py-sm gap-sm max-w-container-max mx-auto">
            <Link
              to="/"
              className={
                "block rounded-md px-md py-sm border-l-4 " +
                mobileLinkClass(isHome)
              }
              onClick={handleMenuClose}
            >
              Home
            </Link>

            <Link
              to="/about"
              className={
                "block rounded-md px-md py-sm border-l-4 " +
                mobileLinkClass(isAbout)
              }
              onClick={handleMenuClose}
            >
              About
            </Link>

            <Link
              to="/services"
              className={
                "block rounded-md px-md py-sm border-l-4 " +
                mobileLinkClass(isServices)
              }
              onClick={handleMenuClose}
            >
              Services
            </Link>

            <Link
              to="/contact"
              className={
                "block rounded-md px-md py-sm border-l-4 " +
                mobileLinkClass(isContact)
              }
              onClick={handleMenuClose}
            >
              Contact Us
            </Link>

            <a
              className="w-full bg-brand-gradient text-on-primary px-md py-sm font-bold rounded-lg hover:brightness-110 transition-all mt-sm text-center"
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
            >
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
